import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { usePlayerEvent } from './usePlayerEvent';
import { useJWPlayerEvent } from './useJWPlayerEvent';

export function useAdProgress() {
  const player = usePlayer();
  const [progress, setProgress] = useState({
    time: player.getCurrentTime(),
    duration: player.getDuration(),
  });

  const handleAdProgress = useCallback((time: number, duration: number) => {
    setProgress({
      time,
      duration,
    });
  }, []);

  const handleCastAdProgress = useCallback(
    (param: jwplayer.CastAdProgressParam) => {
      setProgress({
        time: param.position,
        duration: param.duration,
      });
    },
    []
  );

  usePlayerEvent('adProgress', handleAdProgress);
  useJWPlayerEvent('castAdProgress', handleCastAdProgress);

  return progress;
}
